import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import { FileText, Mail, Calendar, MessageSquare, Newspaper, Tag, Settings } from 'lucide-react';
import WhatsAppStyleNode from './WhatsAppStyleNode';
import { TemplateNodeData } from '../../types/nodes';

const templateIcons = {
  welcome: <Mail />,
  order_confirmation: <FileText />,
  appointment: <Calendar />,
  feedback: <MessageSquare />,
  newsletter: <Newspaper />,
  promotion: <Tag />,
  custom: <Settings />
};

const templateLabels = {
  welcome: 'Benvenuto',
  order_confirmation: 'Conferma Ordine',
  appointment: 'Appuntamento',
  feedback: 'Feedback',
  newsletter: 'Newsletter',
  promotion: 'Promozione',
  custom: 'Personalizzato'
};

const TemplateNode: React.FC<NodeProps<TemplateNodeData>> = memo(({ selected, data }) => {
  const icon = templateIcons[data.templateType] || <FileText />;
  const label = templateLabels[data.templateType] || 'Template';
  
  const getPreview = () => {
    if (data.config.templateId) {
      return `ID: ${data.config.templateId}`;
    }
    if (data.config.customTemplate) {
      return 'Template personalizzato';
    }
    return data.config.language || 'Italiano';
  };

  return (
    <WhatsAppStyleNode
      selected={selected}
      icon={icon}
      label={label}
      preview={getPreview()}
      color="from-indigo-500 to-purple-600"
      handles={{
        target: true,
        source: true,
      }}
    />
  );
});

TemplateNode.displayName = 'TemplateNode';

export default TemplateNode;
